import { render, staticRenderFns } from "./MainLedgerCard5.vue?vue&type=template&id=a7a9aebc&scoped=true"
import script from "./MainLedgerCard5.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard5.vue?vue&type=script&lang=js"
import style1 from "./otvoreneStavke.css?vue&type=style&index=1&id=a7a9aebc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a9aebc",
  null
  
)

export default component.exports